import { adminObjects } from './constants';

import { sharedActions as tlsAccountActions } from '../tlsAccountSettingsPage/store/actions';
import { sharedActions as bookToTaxCodeDescriptionActions } from '../bookToTaxCodesPage/store/actions';
import { fetchSlAdminAccounts, importSlAdminAccounts } from '../slAccountsPage/store/actions';
import { sharedActions as adminTaxEntryActions } from '../adminTaxEntrySettingsPage/store/actions';
import { sharedActions as glJournalsActions, importGlJournals } from '../glJournalsPage/store/actions';
import { importGLAccountList, sharedActions as glAccountListActions } from '../GLAccountListPage/store/actions';
import { importAccountMap, sharedActions as accountMapActions } from '../accountMapPage/store/actions';
import { sharedActions as companyCodesActions, importCompanyCodes } from '../companyCodesPage/store/actions';
import { sharedActions as taxRatesActions, importTaxRatesFromXlsx as importTaxRates } from '../taxRatesPage/store/actions';

import { FIELD_MAPPINGS as tlsAccountFieldMappings } from '../tlsAccountSettingsPage/xlsxImport/constants';
import { FIELD_MAPPINGS as slAccountsFieldMappings } from '../slAccountsPage/xlsxImport/constants';
import { FIELD_MAPPINGS as adminTaxEntryFieldMappings } from '../adminTaxEntrySettingsPage/xlsxImport/constants';
import { FIELD_MAPPINGS as GLAccountListFieldMappings } from '../GLAccountListPage/xlsxImport/constants';
import { FIELD_MAPPINGS as AccountMapFieldMappings } from '../accountMapPage/xlsxImport/constants';
import { FIELD_MAPPINGS as glJournalsFieldMappings } from '../glJournalsPage/xlsxImport/constants';
import { FIELD_MAPPINGS as companyCodesFieldMappings } from '../companyCodesPage/xlsxImport/constants';
import { FIELD_MAPPINGS as taxRatesFieldMappings } from '../taxRatesPage/xlsxImport/constants';

import { FIELD_MAPPINGS as bookToTaxCodeDescriptionsFieldMappings } from '../clientAdministrationPage/bookToTaxCodeDescriptionTab/xlsxImport/constants';

import { sharedSelectors as tlsAccountsSelectors } from '../tlsAccountSettingsPage/store/selectors';
import { slAccountsSelector } from '../slAccountsPage/store/selectors';
import { taxEntriesSelector } from '../adminTaxEntrySettingsPage/store/selectors';
import { sharedSelectors as glJournalsSelectors } from '../glJournalsPage/store/selectors';
import { sharedSelectors as glAccountListSelectors } from '../GLAccountListPage/store/selectors';
import { sharedSelectors as accountMapSelectors } from '../accountMapPage/store/selectors';
import { sharedSelectors as companyCodesSelectors } from '../companyCodesPage/store/selectors';
import { sharedSelectors as taxRatesSelectors } from '../taxRatesPage/store/selectors';
import { sharedSelectors as bookToTaxCodeDescriptionSelectors } from '../bookToTaxCodesPage/store/selectors';

import tlsAccountsColumnDefs from '../../shared/columnDefinitions/tlsAccounts';
import bookToTaxCodeDescriptionsColumnsDefs from '../../shared/columnDefinitions/bookToTaxCodes';
import slAccountsColumnDefs from '../../shared/columnDefinitions/slAccountsPage';
import { exportTaxEntryColumnDefs } from '../../shared/columnDefinitions/adminTaxEntrySettings';
import accountsListColumnDefs from '../../shared/columnDefinitions/glAccountsListPage';
import accountsMapColumnDefs from '../../shared/columnDefinitions/accountsMapPage';
import glJournalsColumnDefs from '../../shared/columnDefinitions/glJournals';
import { adminExportCompanyCodeColumnDefs } from '../../shared/columnDefinitions/companyCodes';
import taxRatesColumnDefs from '../../shared/columnDefinitions/taxRates';

export default ({ value }) => {
  switch (value) {
    case adminObjects.TLS_ACCOUNTS:
      return {
        fetchAction: tlsAccountActions.fetchEntities,
        importAction: tlsAccountActions.importEntities,
        selector: tlsAccountsSelectors.entitiesSelector,
        columnDefs: ({ categories }) => tlsAccountsColumnDefs(categories),
        fieldMappings: ({ categories }) => tlsAccountFieldMappings(categories),
        fileName: 'TLS_ACCOUNTS',
      };
    case adminObjects.BOOK_TO_TAX_CODE_DESCRIPTIONS:
      return {
        fetchAction: bookToTaxCodeDescriptionActions.fetchEntities,
        importAction: bookToTaxCodeDescriptionActions.importEntities,
        selector: bookToTaxCodeDescriptionSelectors.entitiesSelector,
        columnDefs: bookToTaxCodeDescriptionsColumnsDefs,
        fieldMappings: bookToTaxCodeDescriptionsFieldMappings,
        preprocessors: [],
        fileName: 'BOOK_TO_TAX_CODE_DESCRIPTIONS',
      };
    case adminObjects.BSM_TAX_ENTRY:
      return {
        fetchAction: adminTaxEntryActions.fetchEntities,
        importAction: adminTaxEntryActions.importEntities,
        selector: taxEntriesSelector,
        columnDefs: exportTaxEntryColumnDefs,
        fieldMappings: adminTaxEntryFieldMappings,
        fileName: 'BSM_TAX_ENTRY',
      };
    case adminObjects.BSM_GL_JOURNAL:
      return {
        fetchAction: glJournalsActions.fetchEntities,
        importAction: importGlJournals,
        selector: glJournalsSelectors.entitiesSelector,
        columnDefs: glJournalsColumnDefs,
        fieldMappings: glJournalsFieldMappings,
        fileName: 'BSM_GL_JOURNAL',
      };
    case adminObjects.BSM_GL_ACCOUNT_LIST:
      return {
        fetchAction: glAccountListActions.fetchEntities,
        importAction: importGLAccountList,
        selector: glAccountListSelectors.entitiesSelector,
        columnDefs: accountsListColumnDefs,
        fieldMappings: GLAccountListFieldMappings,
        fileName: 'BSM_GL_ACCOUNT_LIST',
      };
    case adminObjects.BSM_GL_ACCOUNT_MAP:
      return {
        fetchAction: accountMapActions.fetchEntities,
        importAction: importAccountMap,
        selector: accountMapSelectors.entitiesSelector,
        columnDefs: accountsMapColumnDefs,
        fieldMappings: AccountMapFieldMappings,
        fileName: 'BSM_GL_ACCOUNT_MAP',
      };
    case adminObjects.BSM_ACCOUNT:
      return {
        fetchAction: fetchSlAdminAccounts,
        importAction: importSlAdminAccounts,
        selector: slAccountsSelector,
        columnDefs: slAccountsColumnDefs,
        fieldMappings: slAccountsFieldMappings,
        fileName: 'BSM_ACCOUNT',
      };
    case adminObjects.COMPANY_CODES:
      return {
        fetchAction: companyCodesActions.fetchEntities,
        importAction: importCompanyCodes,
        selector: companyCodesSelectors.entitiesSelector,
        columnDefs: adminExportCompanyCodeColumnDefs,
        fieldMappings: companyCodesFieldMappings,
        fileName: 'COMPANY_CODES',
      };
    case adminObjects.TAX_RATES:
      return {
        fetchAction: taxRatesActions.fetchEntities,
        importAction: importTaxRates,
        selector: taxRatesSelectors.entitiesSelector,
        columnDefs: taxRatesColumnDefs,
        fieldMappings: taxRatesFieldMappings,
        fileName: 'TAX_RATES',
      };
    default:
      return {
        selector: () => [],
      };
  }
};
